// extracted by mini-css-extract-plugin
module.exports = {"row":"detail_row__2nooL","label":"detail_label__2O3gz"};